// extracted by mini-css-extract-plugin
export default {"icon":"SvgIcon_icon__9ukqK"};